import { render, staticRenderFns } from "./VerificarNotificacionModal.vue?vue&type=template&id=5fd23e6a"
import script from "./VerificarNotificacionModal.vue?vue&type=script&lang=js"
export * from "./VerificarNotificacionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports